import React from 'react';
import { motion } from 'framer-motion';
interface ScreenShellProps {
  children: React.ReactNode;
  center?: boolean;
}
export function ScreenShell({
  children,
  center = false
}: ScreenShellProps) {
  return <motion.section initial={{
    opacity: 0,
    y: 18
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -14
  }} transition={{
    duration: 0.4,
    ease: [0.22, 1, 0.36, 1]
  }} className={`mx-auto flex w-full max-w-md flex-1 flex-col px-5 pb-10 pt-6 ${center ? 'justify-center' : ''}`} data-id="element-24" data-mp="185lh3a5y9hca">
      {children}
    </motion.section>;
}
export function Headline({
  children
}: {
  children: React.ReactNode;
}) {
  return <h1 className="font-display text-[27px] font-semibold leading-[1.2] tracking-tight text-ink" data-id="element-25" data-mp="1r1uxi44bqjzg">
      {children}
    </h1>;
}
export function Subtext({
  children
}: {
  children: React.ReactNode;
}) {
  return <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-26" data-mp="3nwhexks5qu02">{children}</p>;
}